import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../context/ThemeContext';

const ServiceCard = ({ icon, title, description, features, badge, colorAccent = 'primary' }) => {
  const { isDark } = useTheme();
  
  const accentColors = {
    primary: '#00AA66',
    teal: '#14B8A6',
    sky: '#0EA5E9',
    emerald: '#10B981',
  };

  const accentColor = accentColors[colorAccent];

  return (
    <motion.div
      className={`p-8 rounded-2xl transition-all duration-300 relative group ${
        isDark 
          ? 'shadow-neu-dark hover:shadow-neu-dark-hover' 
          : 'shadow-neu-light hover:shadow-neu-light-hover'
      }`}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      whileHover={{ y: -5 }}
      style={{
        background: isDark ? '#212529' : '#E8EDF2'
      }}
    >
      <div
        className="absolute top-0 left-0 w-1 h-16 rounded-r-full"
        style={{ background: accentColor }}
      />

      <div className="flex items-start justify-between mb-6">
        <div 
          className="text-4xl p-4 rounded-xl"
          style={{ 
            color: accentColor,
            background: isDark 
              ? 'rgba(0, 170, 102, 0.1)' 
              : 'rgba(0, 170, 102, 0.08)'
          }}
        >
          {icon}
        </div>
        <span 
          className="px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wide"
          style={{
            color: accentColor,
            background: isDark 
              ? 'rgba(0, 170, 102, 0.15)' 
              : 'rgba(0, 170, 102, 0.1)'
          }}
        >
          {badge}
        </span>
      </div>

      <h3 className={`text-xl font-bold font-manrope mb-3 ${isDark ? 'text-dark-text' : 'text-light-text'}`}>
        {title}
      </h3>
      <p className={`mb-5 text-sm leading-relaxed ${isDark ? 'text-dark-text-secondary' : 'text-light-text-secondary'}`}>
        {description}
      </p>

      <ul className="space-y-2.5">
        {Array.isArray(features) && features.map((feature, index) => (
          <li key={index} className="flex items-start gap-2.5 text-sm">
            <span className="mt-0.5 font-bold" style={{ color: accentColor }}>✓</span>
            <span className={isDark ? 'text-dark-text-secondary' : 'text-light-text-secondary'}>
              {feature}
            </span>
          </li>
        ))}
      </ul>
    </motion.div>
  );
};

export default ServiceCard;
